<template>
  <div id="newapplicationid">
    <v-toolbar flat color="white darken-4" light style="border-bottom-style: solid; border-width: 1px; border-color: lightgrey !important;">
    <v-toolbar-title class="text-xs-center" style="padding-right: 50px;">Submitted applications</v-toolbar-title>
    <div id="addapplbuttonid"  v-if="cansubmit">
      <v-dialog v-model="dialog" persistent max-width="650px">
        <v-btn outline round color="primary" dark slot="activator">New application</v-btn>
        <v-card>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-title>
              <span class="headline">New application</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout row>
                  <v-flex xs12 sm4>
                    <v-text-field
                      v-model="companyname"
                      label="Company"
                      hint="Name of the company for which the application is submitted"
                      :rules="companyRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="isadmin" xs12 sm6 pl-5>
                    <v-select
                      v-model="country"
                      label="Country"
                      required
                      item-value="id"
                      item-text="name"
                      :items="countrylist"
                      :rules="countryRules"
                      hint="Country for which the application is submitted"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 sm4>
                    <v-select
                      v-model="crop"
                      label="Crop"
                      required
                      item-value="id"
                      item-text="name"
                      :items="cropslist"
                      :rules="cropRules"
                      hint="Crop for which the application is submitted"
                    ></v-select>
                  </v-flex>
                    <v-flex xs12 sm6 pl-5>
                    <v-text-field
                      label="Variety"
                      v-model="variety"
                      :rules="varietyRules"
                      maxlength="128"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 sm11>
                    <v-text-field
                    class="myclass"
                      multiLine
                      rows="3"
                      label="Comment"
                      v-model="comment"
                      maxlength="256"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="closeApplicationForm">Close</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="submit"
                :disabled="!valid"
              >
                submit
              </v-btn>
            </v-card-actions>
            </v-form>
        </v-card>
      </v-dialog>
    </div>
    </v-toolbar>
  </div>
</template>

<script>

export default {
  computed: {
    cropslist () {
      return this.$store.getters.getCrops
    },
    countrylist () {
      return this.$store.getters.getCountries
    },
    cropRules () {
      return this.$store.getters.getCroprules
    },
    companyRules () {
      return this.$store.getters.getCompanyrules
    },
    countryRules () {
      return this.$store.getters.getCountryrules
    },
    varietyRules () {
      return this.$store.getters.getVarietyrules
    },
    cansubmit () {
      if ((this.$store.getters.getUsertype === 'user') || (this.$store.getters.getUsertype === 'admin')) {
        return true
      } else {
        return false
      }
    },
    isadmin () {
      if (this.$store.getters.getUsertype === 'admin') {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      // Application will be send as FormData element
      data: new FormData(),
      valid: true,
      crop: null,
      companyname: null,
      comment: ' ',
      variety: null,
      country: null,
      dialog: false
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.data.append('crop_id', this.crop)
        this.data.append('companyname', this.companyname)
        this.data.append('country_id', this.country)
        this.data.append('variety', this.variety)
        this.data.append('comment', this.comment)
        this.dialog = false
        this.submitapplicationform(this.data)
        this.$refs.form.reset()
      }
    },
    submitapplicationform (values) {
      this.$store.dispatch('createApplication', values)
      this.dialog = false
      this.$refs.form.reset()
    },
    closeApplicationForm () {
      this.dialog = false
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
  #addappltitleid{
    width: 30%;
    font-size: 24px;
    float: left;
  }
  #addapplbuttonid{
    float: left;
  }
  #newapplicationid{
    background-color:white;
    width: 100%;
    height: 64px;
    color:black;
    text-align: left;
    padding-top: -1px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: lightgray;
  }
  .select-style {
    border: 1px solid #ccc;
    width: 120px;
    border-radius: 3px;
    overflow: hidden;
    background: #fafafa no-repeat url('../../../assets/images/sort_desc.png') 90% 40%;
}
.select-style select {
    padding: 5px 8px;
    width: 130%;
    border: none;
    box-shadow: none;
    background: transparent;
    background-image: none;
    -webkit-appearance: none;
}
.select-style select:focus {
    outline: none;
}
.dropdown_label{
  font-size: 12px;
  color: rgba(0,0,0,.54);
  text-align: left !important;
  float:left;
}
.card__text{
  padding-top: 1px;
}
.card__title{
  padding-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Submittedapplicationstitle.vue